// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3fCQb","buttons":"PendingPaymentAlert_buttons__2BKSu"};